import loadable from '@loadable/component';

import {
  type INewbuildingPromoCarouselFallbackProps,
  NewbuildingPromoCarouselFallback,
} from '../../components/NewbuildingPromoCarouselFallback';
import type { INewbuildingPromoCarouselContainerProps } from './NewbuildingPromoCarousel';

type TNewbuildingPromoCarouselLoadableContainerProps = INewbuildingPromoCarouselContainerProps &
  INewbuildingPromoCarouselFallbackProps;

export const NewbuildingPromoCarouselLoadableContainer = loadable<TNewbuildingPromoCarouselLoadableContainerProps>(
  () => {
    if (process.env.IS_BROWSER_BUILD) {
      return import('./NewbuildingPromoCarousel').catch(
        /* istanbul ignore next */ () => ({ default: NewbuildingPromoCarouselFallback }),
      );
    }

    return Promise.resolve({
      default: () => null,
    });
  },
);
